import { XSM_BASE_URL, XSM_DOMAIN, XSM_ORIGIN } from "@/common/constants/auth";
import { httpClient } from "./httpClient";

export const getTenants = (params: any) => {
  return httpClient.get("/api/tenants", params);
};

export const getTenant = (id: string) => {
  return httpClient.get(`/api/tenants/${id}`);
};

export const deleteTenant = (id: string) => {
  return httpClient.delete(`/api/tenants/${id}`);
};

export const createTenant = (formModel: any) => {
  return httpClient.post("/api/tenants", formModel);
};

export const updateTenant = (formModel: any, id: string) => {
  return httpClient.put(`/api/tenants/${id}`, formModel);
};

export const updateTechnicalOrgData = (formModel: any, id: string) => {
  return httpClient.put(`/api/tenants/${id}/data`, formModel);
};

export const getTenantLogo = (tenantID: string) => {
  const params: { [param: string]: string } = {};
  params["ID"] = tenantID;
  return httpClient.getImage("/util/tenants/logo", params);
};

export const fetchComponents = async () => {
  const token = localStorage.getItem("access_token");
  // USE AOO_NAME
  try {
    const componentResponses = await fetch(
      `${XSM_BASE_URL}/xsm-api/v1/admin/components?app_name=EVES`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "XSM-Domain": XSM_DOMAIN,
          "XSM-Internal": "true",
          "X-Original-Origin": XSM_ORIGIN,
        },
      }
    );
    const response = await componentResponses.json();
    return response;
  } catch (error) {
    console.error("error", error);
  }
};

export const fetchEVESComponents = async () => {
  return httpClient.get(`/api/tenants-admin-components`);
};
